import React, { useState } from 'react';
import TabSelection from './components/TabSelection';
import SideBar from './components/sidebar';
import FullCourses from './FullCourses';
import Renewals from './Renewals';
import Gifts from './Gifts';
 
const tabs = [
  {
    label: 'Full courses',
    show: { search: true, filters: { date: true, email: false } },
  },
  {
    label: 'Renewals',
    show: { search: true, filters: { date: true, email: false } },
  },
  {
    label: 'Gifts',
    show: { search: true, filters: { date: true, email: true } },
  },
];

const Tabs = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filter, setFilter] = useState({});
  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const [openSideActionBoard, setOpenSideActionBoard] = useState(false);

  return (
    <div>
      {openSideActionBoard && (
        <SideBar
          openSideActionBoard={openSideActionBoard}
          setOpenSideActionBoard={setOpenSideActionBoard}
        />
      )}
      <TabSelection
        tabs={tabs}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        filter={filter}
        setFilter={setFilter}
      />
      <div style={{ gap: '64px' }} className="flex flex-col">
        {currentTab?.label === 'Full courses' && (
          <FullCourses
            searchQuery={searchQuery}
            filter={filter}
            setOpenSideActionBoard={setOpenSideActionBoard}
          />
        )}
      </div>
      <div style={{ gap: '64px' }} className="flex flex-col">
        {currentTab?.label === 'Renewals' && (
          <Renewals
            searchQuery={searchQuery}
            filter={filter}
            setOpenSideActionBoard={setOpenSideActionBoard}
          />
        )}
      </div>
      <div style={{ gap: '64px' }} className="flex flex-col">
        {currentTab?.label === 'Gifts' && (
          <Gifts
            searchQuery={searchQuery}
            filter={filter}
            setOpenSideActionBoard={setOpenSideActionBoard}
          />
        )}
      </div>
    </div>
  );
};

export default Tabs;
